import { LoadingButton } from "@mui/lab";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  MenuItem, Select
} from "@mui/material";
import { useState } from "react";
import { BodyRow } from "src/components/custom-table";
import DataHandlerList from "src/components/data-handler/list";
import EmptyTable from "src/components/emptyTable";
import Map from "src/components/map";

import useRankbonus from "./hooks/useRankbonus";
import Translate from "src/components/translate";

const RankBonus = () => {
  const { state, handleUpdate, onSubmit } = useRankbonus();


  const { data, ...dataProps } = state;

  return (
    <>
      <DataHandlerList dataProps={{ ...dataProps }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Translate>Rank Name</Translate>
              </TableCell>
               {/* <TableCell>
                <Translate>Team Rank</Translate>
              </TableCell> */}
              <TableCell>
                <Translate>Team Rank</Translate>

              </TableCell>
              <TableCell>
                <Translate>Type</Translate>
             </TableCell>
              <TableCell>
                <Translate>Referral Count</Translate>
              </TableCell>
              <TableCell>
                <Translate>Group Product Point</Translate>
              </TableCell>
              {/* <TableCell>
                <Translate>Monthly Maintenance</Translate>
              </TableCell> */}
              {/* <TableCell> */}
                {/* {" "} */}
                {/* <Translate> {"settings.network.referral_bonus"}</Translate> */}
                {/* (%){" "} */}
              {/* </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            <Map
              list={data.slice(1)}
              render={(item) => (
                <Row
                  key={item.id}
                  {...item}

                  data={data}
                  onSubmit={onSubmit}
                  handleUpdate={handleUpdate}
                  {...item}
                />
              )}
            />
          </TableBody>
        </Table>

        <Box textAlign="right">
          <Stack alignItems="flex-end" sx={{ mt: 3 }}>
            <LoadingButton onClick={onSubmit} type="submit" variant="contained">
              <Translate>{"settings.network.update"}</Translate>
            </LoadingButton>
          </Stack>
        </Box>
      </DataHandlerList>
    </>
  );
};

const Row = ({ id, rank_name,type, handleUpdate,referral_rank_id ,referral_count,team_volume,monthly_volume,data}) => {
      const onChange = (e) => {
    handleUpdate(e);
  };
  return (
    <TableRow>
      <TableCell>
         <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={rank_name}
          name="rank_name"
          type="text"
        />
      </TableCell>

   <TableCell>
<TextField
  select
  fullWidth
  SelectProps={{ native: true }}
  onChange={handleUpdate(id)}
  size="small"
  value={referral_rank_id}
  name={"referral_rank_id"}
>
       <option></option>
  {data?.map((rank) => (
    <>
      <option key={rank.id} value={rank.id}>
        {rank.rank_name}
      </option>
    </>
  ))}
</TextField>
 </TableCell>
  <TableCell>
<TextField
  select
  fullWidth
  SelectProps={{ native: true }}
  onChange={handleUpdate(id)}
  size="small"
  value={type}
  name={"type"}
>
      {/* <option>Select Rank</option> */}
    <option value={"team"}>
        {"Team"}
      </option>
          <option value={"direct"}>
        {"Direct"}
      </option>
</TextField>


</TableCell>

      
      <TableCell>
         <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={referral_count}
          name="referral_count"
          type="number"
        />
      </TableCell>
      <TableCell>
         <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={team_volume}
          name="team_volume"
          type="number"
        />
      </TableCell>
       {/* <TableCell>
         <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={monthly_volume}
          name="monthly_volume"
          type="number"
        />
      </TableCell> */}
      

      {/* <TableCell >
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={referral_bonus}
          name="referral_bonus"
          type="number"
        />
      </TableCell> */}
    </TableRow>
  );
};

const LoadingTextField = ({ value, name, handleUpdate,type }) => {
  const [loading, setLoading] = useState(false);
  const onChange = (e) => {
    setLoading(true);
    handleUpdate(e);
  };

  return (
    <TextField
      onWheel={(e) => e.target.blur()}
      type={type}
      onChange={onChange}
      size="small"
      value={value}
      name={name}
      
    />
  );
};

export default RankBonus;
